import { FlightSortCriterion, SortCriterion } from '@honeycomb/data';
export const masterSortTypes = {
    [SortCriterion.RecommendedHighestFirst]: {
        name: 'RECOMMENDED',
        shortName: 'RECOMMENDED',
    },
    [SortCriterion.PriceLowestFirst]: {
        name: 'PRICECHEAPESTFIRST',
        shortName: 'PRICENOBRACKETS',
    },
    [SortCriterion.CustomerRatingHighestFirst]: {
        name: 'CUSTOMERRATINGHIGHESTFIRST',
        shortName: 'CUSTOMERRATINGNOBRACKETS',
    },
    [SortCriterion.StarRatingHighestFirst]: {
        name: 'STARRATINGHIGHESTFIRST',
        shortName: 'STARRATINGNOBRACKETS',
    },
    [SortCriterion.DurationLowestFirst]: {
        name: 'DURATIONQUICKESTFIRST',
        shortName: 'DURATIONNOBRACKETS',
    },
    [FlightSortCriterion.PriceHighestFirst]: {
        name: 'PRICEHIGHESTFIRST',
        shortName: 'PRICENOBRACKETS',
    },
    [FlightSortCriterion.DepartureTimeEarliestFirst]: {
        name: 'DEPARTURETIMEEARLIESTFIRST',
        shortName: 'DEPARTURETIMENOBRACKETS',
    },
    [FlightSortCriterion.DepartureTimeLatestFirst]: {
        name: 'DEPARTURETIMELATESTFIRST',
        shortName: 'DEPARTURETIMENOBRACKETS',
    },
    [FlightSortCriterion.ReturnTimeEarliestFirst]: {
        name: 'RETURNTIMEEARLIESTFIRST',
        shortName: 'RETURNTIMENOBRACKETS',
    },
    [FlightSortCriterion.ReturnTimeLatestFirst]: {
        name: 'RETURNTIMELATESTFIRST',
        shortName: 'RETURNTIMENOBRACKETS',
    },
    [FlightSortCriterion.DurationQuickestFirst]: {
        name: 'DURATIONQUICKESTFIRST',
        shortName: 'DURATIONNOBRACKETS',
    },
    [FlightSortCriterion.DurationLongestFirst]: {
        name: 'DURATIONLONGESTFIRST',
        shortName: 'DURATIONNOBRACKETS',
    },
};
